const styles = {
  root: {
    // paddingX: { xs: 2, lg: 'unset' },
    marginY: { xs: 1, lg: 3 },
    backgroundColor: 'background.default',
    paddingY: 2,
  },

  bgContainer: {
    color: 'secondary.contrastText',
    paddingY: { xs: 3, lg: 7 },
    paddingX: { xs: 3, lg: 7 },
    borderRadius: 1,
    background: 'linear-gradient(197.77deg, #20B0E7 -100.62%, rgba(32, 193, 231, 0.76) -47.89%, #122549 67.17%)',
  },

  title: {
    color: (theme) => `${theme.palette.text.white}!important`,
  },

  tile: {
    backgroundColor: 'transparent!important',
    '&.Tile-root': {
      alignItems: 'start',
    },
    '& .Tile-icon': {
      '& svg': {
        width: 32,
      },
    },
    '& .MuiTypography-root': {
      whiteSpace: 'normal!important',
    },
  },

  subtitle: {
    color: 'common.white',
  },

  buttonContainer: {
    marginTop: 4,
    marginBottom: 2,
  },

  line1: {
    whiteSpace: 'pre-line',
    textAlign: 'left',
    color: (theme) => `${theme.palette.text.white}!important`,
  },

  line2: {
    textAlign: 'left',
    color: (theme) => `${theme.palette.text.white}!important`,
  },

  featureContainer: {
    paddingLeft: { xs: 0, lg: 2 },
    paddingY: { xs: 3, lg: 'unset' },
  },

  bottomContainer: {
    flexDirection: { lg: 'row-reverse' },
    marginY: { xs: 0, lg: 3 },
  },

  disclaimer: {
    color: (theme) => `${theme.palette.text.white}!important`,
  },

}

export default styles
